var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"/img/end.png"}}),_c('p',{staticStyle:{"color":"#EAEAEA"}},[_vm._v(_vm._s(_vm.text1))]),_c('p',{staticStyle:{"color":"#666666"}},[_vm._v(_vm._s(_vm.text2))])])
}
var staticRenderFns = []

export { render, staticRenderFns }